module.exports = __webpack_public_path__ + "static/media/image12.56fc1fb6.png";